import { Component, Input, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { CardViewComponent } from "./card-view/card-view.component";
import { ChargeWeightDetailsComponent } from "./modal/charge-weight-details/charge-weight-details.component";
import { PriceBreakupDetailsComponent } from "./modal/price-breakup-details/price-breakup-details.component";
import { TableViewComponent } from "./table-view/table-view.component";

@Component({
  selector: "select-courier-partner",
  templateUrl: "./select-courier-partner.component.html",
  styleUrls: ["./select-courier-partner.component.scss"]
})
export class SelectCourierPartnerComponent {
  @ViewChild(TableViewComponent) tableViewComponent: TableViewComponent;
  @ViewChild(CardViewComponent) cardViewComponent: CardViewComponent;
  @Input() courierPrices: any[] = [];
  @Input() courierPartnerForm: FormGroup;
  @Input() viewPreference: string;

  constructor(private _dialog: MatDialog) {}

  // When we change courier partner
  setCourierPartnerValue(courierPartner): void {
    this.courierPartnerForm.get("courier").setValue(courierPartner);
  }

  //for charge and weight details in 425px device view
  shippingInfo({ details, heading }) {
    if (
      details?.price?.courierObj?.rateType === "B2B" &&
      heading === "shipping charge details"
    ) {
      this._dialog.open(PriceBreakupDetailsComponent, {
        panelClass: "medium-modal",
        data: { heading, details }
      });
    } else {
      this._dialog.open(ChargeWeightDetailsComponent, {
        panelClass: "small-modal",
        data: { heading, details }
      });
    }
  }

  markFormAsTouched() {
    this.courierPartnerForm.markAllAsTouched();
    this[`${this.viewPreference}Component`].markForCheck();
  }
}
